module.exports = __webpack_public_path__ + "75e032140a5c5ff91d68cc0072af0f76.png";